import { refs, domReady, throttle, booleanDataset, hasBooleanDataset } from '../modules/utils.js';

class TopBar extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    this.isProductPage = false;

    this.refs = refs(this);
    this.#listeners();
    this.#scrollHandle();
    this.#productPageHandle();
    this.#moonPageHandle();

    if (this.querySelector('ann-bar')) {
      booleanDataset(this, 'announcementBar', true);
    }

    setTimeout(() => booleanDataset(this, 'active', true), 1);
  }

  #listeners() { }

  #scrollHandle() {
    let y = window.scrollY;

    const scrollTest = function () {
      const currentY = window.scrollY;

      if (currentY <= 0) {
        booleanDataset(this, 'onTop', true);
      }
      else {
        booleanDataset(this, 'onTop', false);
      }

      if (currentY > y) {
        this.dataset.scrollDirection = 'down';
      }
      else if (currentY < y) {
        this.dataset.scrollDirection = 'up';
      }

      if (this.isProductPage) {
        this.#productPageScrollListener(currentY);
      }

      if (this.isMoonPage) {
        this.#moonPageScrollListener(currentY);
      }

      y = currentY;
    }.bind(this);

    // immediate call
    scrollTest();
    setTimeout(scrollTest, 1000);

    window.addEventListener('scroll', throttle(scrollTest, 50));
  }

  #productPageHandle() {
    if (!!!document.querySelector('product-top')) return;

    this.refs.navBar = this.querySelector('nav-bar');
    this.refs.cartBar = document.querySelector('cart-bar');

    if (!this.refs.cartBar) return;

    this.isProductPage = true;
    this.navBarHeight = this.refs.navBar.offsetHeight;
  }

  #productPageScrollListener(y) {
    const cartBarTop = this.refs.cartBar.getBoundingClientRect().top - this.navBarHeight;
    if (cartBarTop <= 0 && !hasBooleanDataset(this, 'hidden')) {
      booleanDataset(this, 'hidden', true);
    }
    else if (cartBarTop > 0 && hasBooleanDataset(this, 'hidden')) {
      booleanDataset(this, 'hidden', false);
    }
  }

  #moonPageHandle() {
    if (!document.body.classList.contains('layout--pagemoon-routine')) return;


    this.refs.navBar = this.querySelector('nav-bar');
    this.refs.moonBar = document.querySelector('moon-bar');
    if (!this.refs.moonBar) return;

    this.isMoonPage = true;
    this.moonBarHeight = this.refs.moonBar.offsetHeight;


  }

  #moonPageScrollListener(y) {
    const moonBarTop = this.refs.moonBar.getBoundingClientRect().top - this.moonBarHeight;
    if (moonBarTop <= 0 && !hasBooleanDataset(this, 'hidden')) {
      booleanDataset(this, 'hidden', true);
    }
    else if (moonBarTop > 0 && hasBooleanDataset(this, 'hidden')) {
      booleanDataset(this, 'hidden', false);
    }
  }
}

customElements.define('top-bar', TopBar);
